import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder 97",
  "use": "icon-folder 97-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-folder 97\"><path d=\"M460.650667 192a64 64 0 0 1 62.485333 50.133333l3.093333 13.866667H789.333333a64 64 0 0 1 64 64v448a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64h225.984z m0 64H234.666667v512h554.666666V426.666667H498.602667l-37.952-170.666667zM746.666667 640v64H277.333333v-64h469.333334z m42.666666-320H540.437333l9.493334 42.666667H789.333333v-42.666667z\" p-id=\"11279\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol